import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-message-file-preview',
  templateUrl: './message-file-preview.component.html',
  styleUrls: ['./message-file-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageFilePreviewComponent {
  hide: Function;
  minimize: Function;
  fileName: string;
  fileUrl: string;
  header: string;
  supportedFileExtensions = ['doc', 'docx', 'pdf', 'xls', 'xlsx'];

  isFileSupported(extension: string): boolean {
    return this.supportedFileExtensions.includes(extension.toLowerCase());
  }
}
